import { Reservation } from 'rest-client';

export class SetReservationAction {
  static readonly type = '[RESERVATION] Set reservation';
  constructor(public reservation: Reservation) {}
}

export class RemoveReservationAction {
  static readonly type = '[RESERVATION] Remove reservation';
}
